import { CapabilitiesActions } from '../constants/Capabilities';

export function setCapabilities({ isMobile = false, isTablet = false }) {
  return {
    type: CapabilitiesActions.SET_CAPABILITIES,
    data: {
      isMobile,
      isTablet,
    },
  };
}
